import { useCallback } from 'react';

export const useAutoFocus = (shouldAutoFocus = true) =>
  useCallback(
    (inputElement) => {
      if (inputElement && shouldAutoFocus) {
        setTimeout(() => inputElement.select(), 0);
      }
    },
    [shouldAutoFocus]
  );
